
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index3hrfjj_45Oj08A5n20IPd3JFkobRdxxNCE_T0lKlT6YxEMeta } from "/opt/buildhome/repo/apps/disputes/pages/index.vue?macro=true";
import { default as app_45statusUoM2N__458BZponGb8ptwt_45PHbo1Bk6gIwolJqTZ5t24AMeta } from "/opt/buildhome/repo/apps/disputes/pages/app-status.vue?macro=true";
import { default as indexdotDHd52uK2lRxuI9X77ge2ZLzyjrlYD0BqhRSYHwmMMeta } from "/opt/buildhome/repo/apps/disputes/pages/[connectorId]/[claimId]/index.vue?macro=true";
import { default as _91claimLine_936MwO0iJ22ZsTPIkQcZC2lj2oZqEcuq5ObQmOyw6_45OscMeta } from "/opt/buildhome/repo/apps/disputes/pages/[connectorId]/[claimId]/[claimLine].vue?macro=true";
import { default as _91claimId_93LSBqx9DgCamDvNc220ondIe4l6Vy2GT1urpeV8dJYMMMeta } from "/opt/buildhome/repo/apps/disputes/pages/[connectorId]/[claimId].vue?macro=true";
import { default as _91rid_93FAVztuVrZRnW_45aTSK8wDSG5wyW2tTSc9zlj15dt_BVcMeta } from "/opt/buildhome/repo/apps/claim-lab/pages/[connectorId]/claim-lab/[claimId]/[rid].vue?macro=true";
import { default as _91rid_93KkStUjosmYhKm4UmnjH3T8_H_V_grgKin58VALfOQMIMeta } from "/opt/buildhome/repo/apps/claim-lab/pages/[connectorId]/claim-lab/[claimId]/v2/[rid].vue?macro=true";
import { default as _91connectorId_93U0TatuW0wffS81HsBs_luBbuZp7lt6Kkw_45s86ckvbHgMeta } from "/opt/buildhome/repo/apps/claim-lab/pages/[connectorId].vue?macro=true";
import { default as legalPXftdPkBk4BVypl5py2UNHmdRg_Jq1p0tUV3uPR7_7EMeta } from "/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/legal.vue?macro=true";
import { default as auth_45callbackOwXTNdlq9Gi79MczYvxUrBewH5fePFqTW3S9Tb8NMpUMeta } from "/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-callback.vue?macro=true";
import { default as auth_45loginLiuJ2aewqsIckj_8LP8r_45y2kg1aevC0phvVWWA5JLrQMeta } from "/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-login.vue?macro=true";
import { default as auth_45statusdBnapL4nk9x52YjfnhmjwWHCTdX0TwuPmC1g8zjGa4kMeta } from "/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-status.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/apps/disputes/pages/index.vue")
  },
  {
    name: "app-status",
    path: "/app-status",
    meta: app_45statusUoM2N__458BZponGb8ptwt_45PHbo1Bk6gIwolJqTZ5t24AMeta || {},
    component: () => import("/opt/buildhome/repo/apps/disputes/pages/app-status.vue")
  },
  {
    name: "connectorId",
    path: "/:connectorId()",
    component: () => import("/opt/buildhome/repo/apps/claim-lab/pages/[connectorId].vue"),
    children: [
  {
    name: _91claimId_93LSBqx9DgCamDvNc220ondIe4l6Vy2GT1urpeV8dJYMMMeta?.name,
    path: ":claimId()",
    component: () => import("/opt/buildhome/repo/apps/disputes/pages/[connectorId]/[claimId].vue"),
    children: [
  {
    name: "connectorId-claimId",
    path: "",
    component: () => import("/opt/buildhome/repo/apps/disputes/pages/[connectorId]/[claimId]/index.vue")
  },
  {
    name: "connectorId-claimId-claimLine",
    path: ":claimLine()",
    component: () => import("/opt/buildhome/repo/apps/disputes/pages/[connectorId]/[claimId]/[claimLine].vue")
  }
]
  },
  {
    name: "connectorId-claim-lab-claimId-rid",
    path: "claim-lab/:claimId()/:rid()",
    meta: { ...(_91rid_93FAVztuVrZRnW_45aTSK8wDSG5wyW2tTSc9zlj15dt_BVcMeta || {}), ...{"middleware":["claim-lab"]} },
    component: () => import("/opt/buildhome/repo/apps/claim-lab/pages/[connectorId]/claim-lab/[claimId]/[rid].vue")
  },
  {
    name: "connectorId-claim-lab-claimId-v2-rid",
    path: "claim-lab/:claimId()/v2/:rid()",
    meta: { ...(_91rid_93KkStUjosmYhKm4UmnjH3T8_H_V_grgKin58VALfOQMIMeta || {}), ...{"middleware":["claim-lab"]} },
    component: () => import("/opt/buildhome/repo/apps/claim-lab/pages/[connectorId]/claim-lab/[claimId]/v2/[rid].vue")
  }
]
  },
  {
    name: "legal-notice",
    path: "/legal/licensed-content-notice",
    meta: legalPXftdPkBk4BVypl5py2UNHmdRg_Jq1p0tUV3uPR7_7EMeta || {},
    component: () => import("/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/legal.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: auth_45callbackOwXTNdlq9Gi79MczYvxUrBewH5fePFqTW3S9Tb8NMpUMeta || {},
    component: () => import("/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-callback.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: auth_45loginLiuJ2aewqsIckj_8LP8r_45y2kg1aevC0phvVWWA5JLrQMeta || {},
    component: () => import("/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-login.vue")
  },
  {
    name: "auth-status",
    path: "/auth/status",
    meta: auth_45statusdBnapL4nk9x52YjfnhmjwWHCTdX0TwuPmC1g8zjGa4kMeta || {},
    component: () => import("/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-status.vue")
  }
]